import {omit} from 'lodash';

import {addQueryToPath} from '../../../../../libs/shared/core/src/helpers/browser/urlHelpers';
import {fetchApiAsync} from '../../../../../libs/shared/core/src/services/http/http';
import {buildAppQueries} from '../../../../../libs/shared/core/src/services/query/appQueryHelpers';
import {CellsContext} from '../../../../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {ApiConversationSearchQuerySuggestions} from '../../../../models/api/conversationSearchQuerySuggestionsModel';
import {ConversationSearchQueryStringParameters} from '../../../../store/panels/cells/helpers/cellsPanelPathHelpers';
import {InboxesConversationsParametersWithSearch} from '../../../../store/panels/inboxes/parameters/inboxesParameters';
import {
  buildParametersFetchQueryContext,
  buildParametersSearchModifiers,
  buildParametersSearchQuerySuggestionsFetchPath,
} from '../../../../store/panels/inboxes/parameters/inboxesParametersFetchHelpers';

export const searchNoResultsQueries = buildAppQueries('searchNoResults', {
  querySuggestions: (
    parameters: InboxesConversationsParametersWithSearch,
    cellsContext: CellsContext,
    queryStringParameters: ConversationSearchQueryStringParameters,
    shouldFetchQuerySuggestions: boolean,
  ) => ({
    queryKey: [
      omit(parameters.search, ['fromSelection']),
      omit(parameters, ['selection', 'sortDirection', 'sortProperty', 'filters', 'refinement', 'activity']),
      shouldFetchQuerySuggestions,
    ],
    queryFn: async ({company, cancelToken}) => {
      if (!shouldFetchQuerySuggestions) {
        return {
          originalQueryNormalTerms: '',
          searchTermCorrections: [],
        };
      }

      const addedModifier = buildParametersSearchModifiers(parameters, cellsContext);

      const context = buildParametersFetchQueryContext(parameters, cellsContext);
      const path = buildParametersSearchQuerySuggestionsFetchPath(
        parameters,
        parameters.search,
        cellsContext,
      );
      const pathAndQuery = addQueryToPath(path, {context, ...queryStringParameters});

      const rawResults = await fetchApiAsync(
        ApiConversationSearchQuerySuggestions,
        `${company.url}${pathAndQuery}`,
        {
          cancelToken,
        },
      );

      if (!addedModifier) {
        return rawResults;
      }

      // Strip leading location modifier added to the query.
      return {
        originalQueryNormalTerms: rawResults.originalQueryNormalTerms,
        searchTermCorrections: rawResults.searchTermCorrections.map((correction) => ({
          text: correction.text.substring(addedModifier.length).trimStart(),
          textNormalTerms: correction.textNormalTerms,
        })),
      };
    },
  }),
});
